import { Component, Input, OnDestroy } from '@angular/core';
import { Principal } from '../../../../shared';
import { ExperimentalDesignParameters } from '../../../tabs/experimental-design/experimental-design.parameters.model';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyInstanceItem } from '../../study-instances-table-selector/study-instances-table-selector.component';
import { ExperimentalDesignTypeEnum } from '../../../../shared/experimental.design/experimental-design-type.enum';
import { EDIT_TREATMENT_FACTORS_PERMISSIONS } from '../../../../shared/auth/permissions';

@Component({
    selector: 'jhi-choose-environment-modal',
    templateUrl: './choose-environment-modal.component.html',
    styleUrl: './choose-environment-modal.component.scss'
})
export class ChooseEnvironmentModalComponent implements OnDestroy {

    @Input() studyInstanceItems: StudyInstanceItem[] = [];
    @Input() experimentDesignInput: ExperimentalDesignParameters;
    @Input() selectAll: boolean = true;

    datasetId: number;
    titleKey: string;
    headerKey: string;
    descriptionKey: string;
    cancelLabelKey: string;
    continueLabelKey: string;
    isSaving: false;
    continueBehavior: 'close_immediately' | 'persist' = 'persist';
    hideEditTreatmentFactorsBtn: true;

    private confirmSubject = new Subject<any>();
    onContinue$ = this.confirmSubject.asObservable();

    constructor(
        public principal: Principal,
        public modalService: NgbModal,
        public adtiveModal: NgbActiveModal,
        public activeModal: NgbActiveModal,
    ) {
    }

    ngOnDestroy(): void {
        this.confirmSubject.complete();
    }

    getSelectedInstanceIds(): number[] {
        return this.studyInstanceItems.filter((instance) => instance.isChecked).map((instance) => instance.instanceId);
    }

    getSelectedStudyInstanceItems(): StudyInstanceItem[] {
        return this.studyInstanceItems.filter((instance) => instance.isChecked);
    }

    cancel() {
        this.activeModal.dismiss('back');
    }

    continue(fromEditTreatment = false) {
        const selectedStudyInstanceItems = this.getSelectedStudyInstanceItems();
        if (this.continueBehavior === 'close_immediately') {
            this.adtiveModal.close(selectedStudyInstanceItems);
        } else if (this.continueBehavior === 'persist') {
            const params = {};
            params['selectedStudyInstanceItems'] = selectedStudyInstanceItems;
            params['goToEditTreatmentFactors'] = fromEditTreatment;
            this.confirmSubject.next(params); // Emit confirm event with data
        }
    }

    editTreatmentFactors() {
        this.continue(true);
    }

    showEditTreatmentFactors() {
        return (!this.hideEditTreatmentFactorsBtn
            && this.experimentDesignInput?.designType === ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK.id
            && this.principal.hasAnyAuthorityDirect(this.EDIT_TREATMENT_FACTORS_PERMISSIONS)
            && Object.keys(this.experimentDesignInput.treatmentFactorsData).length > 0);
    }

    protected readonly EDIT_TREATMENT_FACTORS_PERMISSIONS = EDIT_TREATMENT_FACTORS_PERMISSIONS;
}

